export default __webpack_public_path__ + "static/media/Double arrows - Icon.fe0470b1.svg";